module.exports = __webpack_public_path__ + "static/media/Pe-icon-7-stroke.dedf2698.svg";


//////////////////
// WEBPACK FOOTER
// ./src/style/iconfont/stroke7/fonts/Pe-icon-7-stroke.svg?d7yf1v
// module id = 2223
// module chunks = 228